import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { useAuthState, useClient } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { Button } from '@app/components/core/button/Button'
import defaultHousingFormPicture from '@app/assets/defaultHousingFormPicture.png'
import { DashboardListCard } from '@app/components/blocks/card/DashboardListCard'
import { DashboardListHousingFormModel } from 'functions/app/dashboard/profile/housingForm/list-followed'
import builderImage from '@app/assets/images/builder.png'
import { FollowingEmptyState } from './FollowingEmptyState'

export const FollowedHousingForms = () => {
  const translations = useTranslations().app.dashboard.followed
  const client = useClient()
  const authState = useAuthState()
  const [housingForms, setHousingForms] = useState<
    DashboardListHousingFormModel[]
  >([])
  const [_, navigate] = useLocation()

  useEffect(() => {
    const close = client
      .query('list-followed-housing-form', { userId: authState.userId })
      .subscribe(setHousingForms)
    return () => close()
  }, [client, authState.userId])

  const unfollow = async (housingFormId: number) => {
    await client.call('follow-housing-form', {
      housingFormId: housingFormId,
    })
  }

  if (housingForms.length === 0) {
    return (
      <FollowingEmptyState
        title={translations.housingForms}
        message={translations.youFollowNoHousingForms}
        imageSrc={builderImage}
        imageAlt={translations.housingForms}
        discoverHref={pages.housingForms}
        discoverLabel={translations.discoverHousingForms}
      />
    )
  }

  return (
    <Column alignItems="stretch">
      <Title.H4 style={{ marginBottom: '0' }}>
        {translations.housingForms}
      </Title.H4>
      {housingForms.map((form) => (
        <DashboardListCard
          key={form.slug}
          title={form.title}
          subtitle={form.subtitle}
          image={form.images?.[0]?.src ?? defaultHousingFormPicture}
          onClick={() => navigate(pages.housingForm(form.slug))}
          action={
            <Button
              variant="secondary"
              size="small"
              label={translations.unfollow}
              onClick={(e) => {
                e.stopPropagation()
                void unfollow(form.id)
              }}
            />
          }
        />
      ))}
    </Column>
  )
}
